module.exports = __webpack_public_path__ + "static/img/13.4164704.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/13.png
// module id = G2SP
// module chunks = 0